// This file is automatically generated. Do not edit manually.

import { AavoObjectRef } from "src/api/generated/common/aavoObject/aavoObjectRef";
import { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ObjectMainDocumentApi {
	export async function getObjectMainDocument(args: {
		objectRef: AavoObjectRef;
	}): Promise<FrontendDownloadFileHandle | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/documents/getObjectMainDocument",
			method: "POST",
			data: {
				objectRef: args.objectRef,
			},
		});
		return response === "" ? null : (response as FrontendDownloadFileHandle | null);
	}
}
